import React from 'react';

const HowItWorksNG = ({buttonBuyingFaster}) => {
  return (
    <>
      <div className="step d-md-flex align-items-md-stretch">
        <div className="mobile-screen">
          <img src="/images/v2/buyers/create-offer.png" alt="Create offer"/>
        </div>
        <div className="step-content">
          <div>
            <h4>Create an offer and send to your seller</h4>
            <p>
              Using PayOnDelivery, you can create a prepaid offer that you can send to the seller.
              The money will be held securely by POD.
            </p>
            {buttonBuyingFaster}
          </div>
        </div>
      </div>

      <div className="step d-md-flex flex-md-row-reverse align-items-md-stretch">
        <div className="mobile-screen">
          <img src="/images/v2/buyers/seller-accepts.png" alt="Seller accepts the offer"/>
        </div>
        <div className="step-content">
          <div>
            <h4>Seller accepts the offer and ships the item </h4>
            <p>
              Seller will ship the item using the shipping details provided by POD.
              The transaction will be initiated only when the item is shipped.
            </p>
            {buttonBuyingFaster}
          </div>
        </div>
      </div>

      <div className="step d-md-flex align-items-md-stretch">
        <div className="mobile-screen">
          <img src="/images/v2/buyers/item-delivered.png" alt="Item delivered"/>
        </div>
        <div className="step-content">
          <div>
            <h4>The item is delivered to your door step</h4>
            <p>
              After the item is delivered, you have 24h to verify the item. The payment will be released
              only when you have accepted the item.
            </p>
            {buttonBuyingFaster}
          </div>
        </div>
      </div>
    </>
  )
}

export default HowItWorksNG;
